var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllservices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68081 19.831L0.507812 20.473L1.68081 21.115L2.32281 22.288L2.96481 21.115L4.13781 20.473L2.96481 19.831L2.32281 18.658L1.68081 19.831Z",
    fill: "#2DCBE0",
    stroke: "#2DCBE0",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10394 17.769L3.46094 18.121L4.10394 18.473L4.45594 19.117L4.80794 18.473L5.45194 18.121L4.80794 17.769L4.45594 17.126L4.10394 17.769Z",
    fill: "#2DCBE0",
    stroke: "#2DCBE0",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57466 22.4489L3.93066 22.8009L4.57466 23.1529L4.92666 23.7959L5.27866 23.1529L5.92166 22.8009L5.27866 22.4489L4.92666 21.8049L4.57466 22.4489Z",
    fill: "#2DCBE0",
    stroke: "#2DCBE0",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2506 2.90896L18.0776 3.55096L19.2506 4.19296L19.8926 5.36596L20.5346 4.19296L21.7076 3.55096L20.5346 2.90896L19.8926 1.73596L19.2506 2.90896Z",
    fill: "#2DCBE0",
    stroke: "#2DCBE0",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6748 0.846979L21.0308 1.19898L21.6748 1.55098L22.0268 2.19498L22.3788 1.55098L23.0218 1.19898L22.3788 0.846979L22.0268 0.203979L21.6748 0.846979Z",
    fill: "#2DCBE0",
    stroke: "#2DCBE0",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1445 5.52693L21.5005 5.87893L22.1445 6.23093L22.4965 6.87393L22.8485 6.23093L23.4915 5.87893L22.8485 5.52693L22.4965 4.88293L22.1445 5.52693Z",
    fill: "#2DCBE0",
    stroke: "#2DCBE0",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5446 6.34094H11.3386H5.13258L1.89258 10.4669L11.3386 21.8099L20.7846 10.4669L17.5446 6.34094Z",
    stroke: "#2DCBE0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89258 10.4669H20.7846",
    stroke: "#2DCBE0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13281 6.34094L7.51081 10.4669L11.3388 6.34094",
    stroke: "#2DCBE0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5444 6.34094L15.1664 10.4669L11.3384 6.34094",
    stroke: "#2DCBE0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 10.4669L11.3387 21.8099L7.51074 10.4669",
    stroke: "#2DCBE0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllservices);
export default __webpack_public_path__ + "static/media/allservices.41ca8b9d7061d27391e769da774ef61b.svg";
export { ForwardRef as ReactComponent };